/* eslint-env browser */
export var subtle = crypto.subtle;
export var getRandomValues = crypto.getRandomValues.bind(crypto);